import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import { useT } from '../../hooks/useT';
import styles from './ProfileHero.module.css';

function ProfileHero({ profileInitials, profileImage, nameKey, titleKey, bioKey, showDivider = true, ctaKey, ctaLink }) {
  const t = useT();

  return (
    <div className={styles.hero}>
      <div className={styles.profileFrame}>
        {profileImage ? (
          <img src={profileImage} alt={t(nameKey)} className={styles.profileImage} />
        ) : (
          <div className={styles.profilePlaceholder}>{profileInitials}</div>
        )}
      </div>
      <h1 className={styles.name}>{t(nameKey)}</h1>
      <h2 className={styles.title}>{t(titleKey)}</h2>
      {showDivider && <div className={styles.divider} />}
      {bioKey && <p className={styles.bio}>{t(bioKey)}</p>}
      {ctaKey && ctaLink && (
        <Link to={ctaLink} className={styles.cta}>
          {t(ctaKey)} <FaArrowRight className={styles.ctaIcon} />
        </Link>
      )}
    </div>
  );
}

export default ProfileHero;
